import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Link } from "react-router-dom";
import SectionHeader from "@/components/SectionHeader";
import { ArrowRight, Clock } from "@phosphor-icons/react";
import { Badge } from "@/components/ui/badge";
import PageSEO from "@/components/PageSEO";

export default function Insights() {
  const [posts, setPosts] = useState([]);
  const [cat, setCat] = useState("all");
  const cats = ["all", "Investment Education", "Financial Literacy", "Real Estate", "Agriculture", "Business", "Mayoto News"];

  useEffect(() => { http.get("/blog").then(r => setPosts(r.data)).catch(() => {}); }, []);
  const list = cat === "all" ? posts : posts.filter(p => p.category === cat);

  return (
    <div>
      <PageSEO
        title="Financial literacy, sector analysis and thoughtful investing"
        description="Mayoto Insights — practical articles on investing in Nigeria across real estate, agriculture and strategic business. Curated financial literacy for community-first investors."
        canonicalPath="/insights"
      />
      <section className="mayo-grain">
        <div className="container-wide py-20 lg:py-24">
          <p className="text-[#00b4d8] font-display font-bold tracking-[0.25em] text-xs">MAYOTO INSIGHTS</p>
          <h1 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-[#0a1128] max-w-3xl" data-testid="insights-title">
            Financial literacy, sector analysis, and thoughtful investing.
          </h1>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container-wide">
          <div className="flex flex-wrap gap-2 mb-10">
            {cats.map(c => (
              <button key={c} onClick={() => setCat(c)} data-testid={`insights-cat-${c.replace(/\s+/g,"-").toLowerCase()}`}
                className={`text-sm rounded-full px-4 py-2 transition-colors ${cat === c ? "bg-[#0a1128] text-white" : "bg-slate-100 text-slate-700 hover:bg-slate-200"}`}>
                {c === "all" ? "All" : c}
              </button>
            ))}
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {list.map(p => (
              <Link key={p.id} to={`/insights/${p.slug}`} className="card-lift bg-white border border-slate-200 rounded-2xl overflow-hidden flex flex-col" data-testid={`insights-card-${p.slug}`}>
                {p.image_url && (
                  <div className="aspect-video overflow-hidden bg-slate-100">
                    <img src={p.image_url} alt={p.title} className="h-full w-full object-cover transition-transform duration-500 hover:scale-105" />
                  </div>
                )}
                <div className="p-6 flex-1 flex flex-col">
                  <div className="flex items-center gap-2 mb-3">
                    <Badge className="bg-[#00b4d8]/10 text-[#00b4d8] hover:bg-[#00b4d8]/10">{p.category}</Badge>
                    <span className="text-xs text-slate-500 inline-flex items-center gap-1"><Clock size={12} />{p.reading_time}</span>
                  </div>
                  <h3 className="font-display font-bold text-xl text-[#0a1128] leading-tight">{p.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 line-clamp-3">{p.excerpt}</p>
                  <p className="mt-auto pt-4 text-sm font-semibold text-[#00b4d8] inline-flex items-center gap-1">Read article <ArrowRight size={14} /></p>
                </div>
              </Link>
            ))}
            {list.length === 0 && <div className="col-span-full text-slate-500">No insights yet — check back soon.</div>}
          </div>
        </div>
      </section>
    </div>
  );
}
